<div [formGroup]="form" *ngIf="form">

  <div class="dialog-line">
    <div class="dialog-line">
      <div class="label" title="Code Etablissement">Code Etablissement</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="codeEtablissement"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
    <div class="dialog-line">
      <div class="label" title="Nom Client">Nom du client</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="nomClient"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
  </div>

  <div class="dialog-line">
    <div class="dialog-line">
      <div class="label" title="Access Token">Token</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="accessToken"
          [mode]="!canModify ? 'password' : 'text'"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
    <div class="dialog-line">
      <div class="label" title="Code ELAP de l'article Frais de port">Code Frais de port</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="codeArticleFraisPort"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
  </div>

  <div class="dialog-line">
    <div class="dialog-line">
      <div class="label" title="Dispo Achat">Dispo Achat</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="dispoAchat"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
    <div class="dialog-line">
      <div class="label" title="Compte Contrepartie">Compte Contrepartie</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="compteContrepartie"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
  </div>

  <div class="dialog-line">
    <div class="dialog-line">
      <div class="label" title="Compte Charge">Compte Charge</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="compteCharge"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
    <div class="dialog-line">
      <div class="label" title="Compte FNP">Compte FNP</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="compteFNP"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
  </div>

  <div class="dialog-line">
    <div class="dialog-line">
      <div class="label" title="Nature Achat">Nature Achat</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="natureAchat"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
    <div class="dialog-line">
      <div class="label" title="Destination Achat">Destination Achat</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="destinationAchat"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
  </div>

  <div class="dialog-line">
    <div class="dialog-line">
      <div class="label" title="WorkFlow Etape Initiale EJ">WfEtapeInitiale EJ</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="EJwfEtapeInitiale"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
    <div class="dialog-line">
      <div class="label" title="WorkFlow Transistion EJ">WfTransition EJ</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="EJwfTransition"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
  </div>

  <div class="dialog-line">
    <div class="dialog-line">
      <div class="label" title="WorkFlow Etape Initiale SF">WfEtapeInitiale SF</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="SFwfEtapeInitiale"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
    <div class="dialog-line">
      <div class="label" title="WorkFlow Transistion SF">WfTransition SF</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="SFwfTransition"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
  </div>

  <div class="dialog-line">
    <div class="dialog-line">
      <div class="label" title="Statut des bons de commandes à exporter">Statut bons cf <span class="danger-color">*</span></div>
      <div class="value">
        <yo-lookup
          #bonCfStatutExportLookup
          [data]="bonCfStatutList"
          [selectedItem]="idSelectedBonCfStatutExport"
          autoSelect="false"
          (onValueChange)="onChangeBonCfStatutExport($event)"
          [disabled]="!canModify">
        </yo-lookup>
      </div>
    </div>
    <div class="dialog-line">
      <div class="label" title="Exercice">Exercice</div>
      <div class="value">
        <dx-text-box
          class="inputfield"
          formControlName="exercice"
          [disabled]="!canModify">
        </dx-text-box>
      </div>
    </div>
  </div>

</div>
